
import { AxiosResponse } from 'axios'
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import { downloadDirect } from '@/helpers/commons/fileHelper'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import fileDescriptor from './DatasetManagementFileDataset.json'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import KnInputFile from '@/components/UI/KnInputFile.vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default defineComponent({
    components: { Card, KnValidationMessages, KnInputFile, Dropdown, DataTable, Column },
    props: { selectedDataset: { type: Object as any }, dataSources: { type: Array as any } },
    emits: ['touched', 'fileUploaded', 'checkFormulaForParams'],
    data() {
        return {
            v$: useValidate() as any,
            fileDescriptor,
            dataset: {} as any,
            triggerUpload: false,
            uploading: false,
            loading: false,
            expandTableCard: true,
            columns: [] as any,
            rows: [] as any
        }
    },
    created() {
        this.dataset = this.selectedDataset
        this.dataset.id ? this.getPreviewData() : ''
    },
    watch: {
        selectedDataset() {
            this.dataset = this.selectedDataset
            this.dataset.id ? this.getPreviewData() : ''
        }
    },
    validations() {
        const fileFieldsRequired = (value) => {
            return this.dataset.dsTypeCd != 'File' || value
        }
        const customValidators: ICustomValidatorMap = { 'file-fields-required': fileFieldsRequired }
        const validationObject = { dataset: createValidations('dataset', fileDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {
        setUploadType() {
            this.triggerUpload = false
            setTimeout(() => (this.triggerUpload = true), 200)
        },
        uploadDatasetFile(event) {
            this.uploading = true
            let uploadedFile = event.target.files[0]

            this.startUpload(uploadedFile)

            this.triggerUpload = false
            setTimeout(() => (this.uploading = false), 200)
        },
        async startUpload(uploadedFile) {
            var formData = new FormData()
            formData.append('file', uploadedFile)
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `selfservicedatasetupload/fileupload`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryFYwjkDOpT85ZFN3L'
                    }
                })
                .then((response: AxiosResponse<any>) => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.uploading'),
                        msg: this.$t('importExport.import.successfullyCompleted')
                    })
                    this.dataset.fileType = response.data.fileType
                    this.dataset.fileName = response.data.fileName
                    this.$emit('fileUploaded')
                    this.resetFields()
                    this.getPreviewData()
                })
                .catch()
                .finally(() => {
                    this.triggerUpload = false
                })
        },
        resetFields() {
            this.dataset.csvEncoding = 'UTF-8'
            this.dataset.csvDelimiter = ','
            this.dataset.dateFormat = 'dd/MM/yyyy'
            this.dataset.timestampFormat = 'dd/MM/yyyy HH:mm:ss'
            this.dataset.csvQuote = '"'
            this.dataset.skipRows = 0
            this.dataset.limitRows = null
            this.dataset.xslSheetNumber = 1

            if (this.dataset.fileType == 'XLS' || this.dataset.fileType == 'XLSX') {
                this.dataset.limitRows = ''
                this.dataset.csvDelimiter = ''
                this.dataset.dateFormat = ''
                this.dataset.timestampFormat = ''
                this.dataset.csvQuote = ''
            }
        },

        async downloadDatasetFile() {
            var encodedLabel = encodeURI(this.dataset.label)
            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/datasets/download/file?dsLabel=${encodedLabel}&type=${this.dataset.fileType}`, {
                    headers: {
                        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
                        responseType: 'arraybuffer'
                    }
                })
                .then(
                    (response: AxiosResponse<any>) => {
                        if (response.data.errors) {
                            this.$store.commit('setError', { title: this.$t('common.error.downloading'), msg: this.$t('common.error.errorCreatingPackage') })
                        } else {
                            this.$store.commit('setInfo', { title: this.$t('common.toast.success') })
                            if (response.headers) {
                                downloadDirect(response.data, this.createCompleteFileName(response), response.headers['content-type'])
                            }
                        }
                    },
                    (error) =>
                        this.$store.commit('setError', {
                            title: this.$t('common.error.downloading'),
                            msg: this.$t(error)
                        })
                )
        },
        createCompleteFileName(response) {
            var contentDisposition = response.headers['content-disposition']
            var fileAndExtension = contentDisposition.match(/filename[^;\n=]*=((['"]).*?\2|[^;\n]*)/i)[1]
            var completeFileName = fileAndExtension.replaceAll('"', '')
            return completeFileName
        },
        async getPreviewData(metadata: Boolean = true) {
            this.loading = true
            this.dataset.limit = 10
            if (!metadata) delete this.dataset.meta

            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/datasets/preview`, this.dataset, {
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'application/json;charset=UTF-8',
                        'X-Disable-Errors': 'true'
                    }
                })
                .then((response: AxiosResponse<any>) => {
                    this.columns = []
                    let previewColumns = response.data.metaData.fields
                    previewColumns.forEach((el: any) => {
                        typeof el != 'object' ? '' : this.columns.push(el)
                    })

                    this.rows = response.data.rows
                })
                .catch()
                .finally(() => (this.loading = false))
        }
    }
})
